
export const DEFAULT_REQUEST_TIMEOUT_MS = 60_000;

export interface RequestGuard {
  signal: AbortSignal;
  timedOut: () => boolean;
  dispose: () => void;
}

export function createRequestGuard(userSignal: AbortSignal | undefined, timeoutMs: number): RequestGuard {
  const ctrl = new AbortController();
  let timedOut = false;

  const onUserAbort = () => ctrl.abort(userSignal?.reason);
  if (userSignal?.aborted) ctrl.abort(userSignal.reason);
  else userSignal?.addEventListener('abort', onUserAbort, { once: true });

  const timer =
    timeoutMs > 0
      ? setTimeout(() => {
          timedOut = true;
          ctrl.abort(new DOMException('Request timed out', 'TimeoutError'));
        }, timeoutMs)
      : null;

  return {
    signal: ctrl.signal,
    timedOut: () => timedOut,
    dispose: () => {
      if (timer !== null) clearTimeout(timer);
      userSignal?.removeEventListener('abort', onUserAbort);
    },
  };
}

export function isAbortError(err: unknown): boolean {
  return typeof err === 'object' && err !== null && (err as { name?: string }).name === 'AbortError';
}
